/* Bundle builder (PDP): "Complete Your Bike".
   Bundles come from the Bundles section config (pure theme settings).
   Band-matched bundles show as cards; every other bundle valid for
   this bike's type is reachable via the "more options" dropdown.
   The selected bundle's components ride along when the theme's own
   add-to-cart submits, tagged with a bundle line property. Checkout
   pricing comes from matching automatic discounts in admin. */
(function () {
  var host = document.querySelector('[data-bundle-builder]');
  var configEl = document.getElementById('bundle-config');
  if (!host || !configEl || host.dataset.bbInit) return;
  host.dataset.bbInit = '1';

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

  var GROUPS = {
    road_tt: ['Road Bike', 'TT Bike'],
    gravel_cx: ['Gravel/CX Bike'],
    hybrid_mtb: ['MTB', 'Hybrid'],
  };

  var ptype = host.getAttribute('data-product-type');
  var pounds = parseInt(host.getAttribute('data-product-price'), 10) / 100;

  function typeOk(b) {
    if (b.group === 'any') return true;
    var types = GROUPS[b.group];
    return !!types && types.indexOf(ptype) !== -1;
  }
  function bandOk(b) {
    if (b.min && pounds < b.min) return false;
    if (b.max && pounds >= b.max) return false;
    return true;
  }

  var eligible = (config.bundles || []).filter(function (b) {
    if (!b.available || !typeOk(b)) return false;
    return b.bundleProduct ? true : !!(b.pedal && b.cage);
  });
  // de-dupe by name (Ride-Ready exists twice for targeting reasons)
  var seen = {};
  eligible = eligible.filter(function (b) {
    if (seen[b.name]) return false;
    seen[b.name] = true;
    return true;
  });
  var matched = eligible.filter(bandOk).slice(0, 2);
  if (!matched.length) return;
  var others = eligible.filter(function (b) { return matched.indexOf(b) === -1; });
  var all = matched.concat(others);

  function money(cents) {
    var whole = Math.floor(cents / 100);
    var grouped = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var pence = Math.round(cents % 100);
    return '£' + grouped + (pence ? '.' + (pence < 10 ? '0' : '') + pence : '');
  }
  function priceOf(b) { return b.bundleProduct ? b.bundleProduct.price : b.pedal.price + b.cage.price * b.cageQty; }
  function compareOf(b) {
    if (b.bundleProduct) return b.bundleProduct.compareAt > b.bundleProduct.price ? b.bundleProduct.compareAt : 0;
    return 0;
  }

  var itemsWrap = host.querySelector('.bundle-builder__items');

  function cardFor(index) {
    var b = all[index];
    var compare = compareOf(b);
    var row = document.createElement('div');
    row.className = 'bundle-builder__item';
    row.setAttribute('data-index', index);
    row.setAttribute('role', 'checkbox');
    row.setAttribute('aria-checked', 'false');
    row.setAttribute('tabindex', '0');
    row.innerHTML =
      '<span class="bundle-builder__check"></span>' +
      '<span class="bundle-builder__thumb">' +
        (b.bundleProduct
          ? (b.bundleProduct.image ? '<img src="' + b.bundleProduct.image + '" alt="" loading="lazy">' : '')
          : (b.pedal.image ? '<img src="' + b.pedal.image + '" alt="" loading="lazy">' : '') +
            (b.cage.image ? '<img src="' + b.cage.image + '" alt="" loading="lazy">' : '')) +
      '</span>' +
      '<span class="bundle-builder__meta">' +
        '<span class="bundle-builder__name">' + b.name + '</span>' +
        (function () {
          var contents = b.contents || (b.bundleProduct ? '' : b.pedal.title + ' + ' + b.cageQty + '× ' + b.cage.title);
          return contents && contents !== b.name ? '<span class="bundle-builder__contents">' + contents + '</span>' : '';
        })() +
      '</span>' +
      '<span class="bundle-builder__prices">' +
        '<span class="bundle-builder__cost">' + money(priceOf(b)) + '</span>' +
        (compare ? '<s class="bundle-builder__rrp">' + money(compare) + '</s>' : '') +
      '</span>';
    return row;
  }

  // one card at a time; the header dropdown swaps which bundle is shown
  var currentCard = cardFor(0);
  itemsWrap.appendChild(currentCard);

  if (all.length > 1) {
    var moreSelect = document.createElement('select');
    moreSelect.className = 'bundle-builder__more';
    moreSelect.setAttribute('aria-label', 'Choose a bundle');
    moreSelect.innerHTML = all.map(function (b, i) { return { b: b, i: i }; })
      .sort(function (x, y) { return priceOf(x.b) - priceOf(y.b); })
      .map(function (o) {
        return '<option value="' + o.i + '"' + (o.i === 0 ? ' selected' : '') + '>' + o.b.name + ' · ' + money(priceOf(o.b)) + '</option>';
      }).join('');
    host.querySelector('.bundle-builder__head').appendChild(moreSelect);
    moreSelect.addEventListener('change', function () {
      var wasSelected = currentCard.classList.contains('is-selected');
      var fresh = cardFor(parseInt(moreSelect.value, 10));
      currentCard.replaceWith(fresh);
      currentCard = fresh;
      if (wasSelected) {
        fresh.classList.add('is-selected');
        fresh.setAttribute('aria-checked', 'true');
      }
    });
  }

  function selectedRow() {
    return itemsWrap.querySelector('.bundle-builder__item.is-selected');
  }

  function toggle(row) {
    var turningOn = !row.classList.contains('is-selected');
    itemsWrap.querySelectorAll('.bundle-builder__item').forEach(function (r) {
      r.classList.remove('is-selected');
      r.setAttribute('aria-checked', 'false');
    });
    row.classList.toggle('is-selected', turningOn);
    row.setAttribute('aria-checked', String(turningOn));
  }

  itemsWrap.addEventListener('click', function (e) {
    var row = e.target.closest('.bundle-builder__item');
    if (row) toggle(row);
  });
  itemsWrap.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Enter') return;
    var row = e.target.closest('.bundle-builder__item');
    if (row) { e.preventDefault(); toggle(row); }
  });
  host.hidden = false;

  var form = document.querySelector('.product-form form[data-type="add-to-cart-form"]');
  if (!form) return;
  var adding = false;
  form.addEventListener('submit', function () {
    var row = selectedRow();
    if (!row || adding) return;
    adding = true;
    var b = all[parseInt(row.getAttribute('data-index'), 10)];
    var prop = { _added_from: 'bundle:' + b.name };
    var items = b.bundleProduct
      ? [{ id: b.bundleProduct.variantId, quantity: 1, properties: prop }]
      : [
          { id: b.pedal.variantId, quantity: 1, properties: prop },
          { id: b.cage.variantId, quantity: b.cageQty, properties: prop },
        ];
    setTimeout(function () {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          if (r.ok && window.refreshCart) window.refreshCart();
          toggle(row); // clears selection
          adding = false;
        })
        .catch(function () { adding = false; });
    }, 700);
  });
})();
